import AuthenticatedTemplate from "../../components/AuthenticatedTemplate";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

import Button from "../../components/form/Button";
import { Footer } from "../../components/Footer";
import { UploadFile } from "../../components/UploadFile";
import { useServicesStore } from "../../stores/options-store";

import { ICONS, LOGOS } from "../../utils/assets";
import ProgressBar from "../../components/ProgressBar";
import { useGlobalStore } from "../../stores/global-store";

export const Dashboard02UpdateDetails = () => {
  const [libraries] = useState(["places"]);
  const [isOpen, setOpen] = useState({
    from: true,
    to: true,
  });

  const [errors, setErrors] = useState({});
  const [displayUploadDoc, setDisplayUploadDoc] = useState(false);

  const navigate = useNavigate();

  const { fetchGender, gender } = useGlobalStore();
  const { services } = useServicesStore();

  const [displayDetails, setDisplayDatails] = useState({});

  const [listDetails, setListDetails] = useState({
    addressFromStr: "",
    addressToStr: "",
    addressFromArray: {},
    addressToArray: {},
    moveOutDate: "",
    moveInDate: "",
    emailFrom: "",
    emailTo: "",
    givenNameFrom: "",
    givenNameTo: "",
    middleNameFrom: "",
    middleNameTo: "",
    familyNameFrom: "",
    familyNameTo: "",
    mobileNumberFrom: "",
    mobileNumberTo: "",
    genderFromDesc: "",
    genderToDesc: "",
    genderFromId: 0,
    genderToId: 0,
    datesToString: {
      moveOutDate: "",
      moveInDate: "",
    },
  });

  /**
   * useEffect to get all items from the sessionStorage and save it on
   * useState to display in the screen
   */
  useEffect(() => {
    const initialize = async () => {
      try {
        const hasSelectedService = (service) =>
          services.some((s) => s === service);
        const isGenderSelected = hasSelectedService("gender");
        const isNameSelected = hasSelectedService("name");

        //Validation to display the Upload Document function
        if (isGenderSelected || isNameSelected) {
          setDisplayUploadDoc(true);
        }
        //Validation to display the call and display the gender list
        if (isGenderSelected) {
          await fetchGender();
        }

        await fetchDataPersonalDetails();
        // await fetchGetIdVerification();
      } catch (error) {
        console.error("Error initializing data:", error);
      }
    };

    displayDetailsSelected();
    initialize();
  }, []);

  /**
   * Google Maps API
   */
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  // Helper function to get data from local storage
  async function getDataLocalStorage(key) {
    try {
      const data = sessionStorage.getItem(key); // Fetch data from sessionStorage

      if (!data) {
        throw new Error(`No data found for key: ${key}`); // Throw an error if no data exists
      }
      return JSON.parse(data); // Parse and return the data
    } catch (error) {
      console.error(
        `Error retrieving data from sessionStorage: ${error.message}`
      );
      return null; // Return null to indicate failure
    }
  }
  /**
   * Function to check if the email retrieved from the Token Claim is registred in the Database
   */
  async function fetchDataPersonalDetails() {
    const { email } = await getDataLocalStorage("LS_CUSTOMER_INFO");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/get-email-personal-details`,
        {
          email,
        }
      );

      if (response.data?.[0]) {
        sessionStorage.setItem(
          "LS_PERSONAL_DETAILS",
          JSON.stringify(response.data[0])
        );
      }
    } catch (error) {
      console.error(
        "Error fetching personal details:",
        error?.response?.data || error.message
      );
    }
  }

  /**
   * Loads details array from sessionStorage or creates an empty array if none is found.
   */
  async function populateDetailArray() {
    let detailsArray = listDetails;

    const LS_DATA_DETAILS = sessionStorage.getItem("LS_DETAILS");
    if (LS_DATA_DETAILS) {
      detailsArray = JSON.parse(LS_DATA_DETAILS);
    } else {
      const LS_PERSONAL_DETAILS = sessionStorage.getItem("LS_PERSONAL_DETAILS");
      if (LS_PERSONAL_DETAILS) {
        const personalDetailsArr = JSON.parse(LS_PERSONAL_DETAILS);

        // Map personal details to local address object
        const LocalAddressObject = Object.assign(
          {},
          {
            Local_Address_Building_Name:
              personalDetailsArr.Res_Address_Building_Name || "",
            Local_Address_Unit_Number:
              personalDetailsArr.Res_Address_Unit_Number || "",
            Local_Address_Street_Number:
              personalDetailsArr.Res_Address_Street_Number || "",
            Local_Address_Street_Name:
              personalDetailsArr.Res_Address_Street_Name || "",
            Local_Address_Suburb: personalDetailsArr.Res_Address_Suburb || "",
            Local_Address_City: personalDetailsArr.Res_Address_City || "",
            Local_Address_State_Region:
              personalDetailsArr.Res_Address_State_Regio || "",
            Local_Address_Country: personalDetailsArr.Res_Address_Country || "",
            Local_Address_Post_Code:
              personalDetailsArr.Res_Address_Post_Code || "",
          }
        );
        // Assign mapped address object and gender
        detailsArray.addressFromArray = LocalAddressObject;
        const genderOptionDesc =
          gender.find((item) => item.Gender_ID === personalDetailsArr.Gender)
            ?.Gender_Description || "";
        // Construct full address as string
        const addressFromConcat = `${personalDetailsArr.Res_Address_Street_Number} ${personalDetailsArr.Res_Address_Street_Name}, ${personalDetailsArr.Res_Address_Suburb}, ${personalDetailsArr.Res_Address_City}, NZ ${personalDetailsArr.Res_Address_Post_Code}`;
        // Assign details to detailsArray
        Object.assign(detailsArray, {
          addressFromStr: addressFromConcat,
          emailFrom: personalDetailsArr.Email,
          givenNameFrom: personalDetailsArr.Given_Name,
          middleNameFrom: personalDetailsArr.Middle_Name,
          familyNameFrom: personalDetailsArr.Surname,
          mobileNumberFrom: personalDetailsArr.Mobile_Number,
          genderFromDesc: genderOptionDesc,
        });
        // Update local storage with populated detailsArray
        await updateLocalStorage(detailsArray);
      }
    }

    // Update state with populated detailsArray
    setListDetails(detailsArray);
    return detailsArray;
  }

  /**
   * Function to updated the local Storage
   */
  async function updateLocalStorage(detailsArray) {
    sessionStorage.setItem("LS_DETAILS", JSON.stringify(detailsArray));
  }

  function displayDetailsSelected() {
    const displayArray = {
      address: false,
      name: false,
      gender: false,
      emailAddress: false,
      mobileNumber: false,
    };
    if (services) {
      services.forEach((item) => {
        displayArray[item] = true;
      });

      setDisplayDatails(displayArray);
    }
  }

  /**
   * Functions to get the address selected in the Input and call the
   * populateAddressObject function to filter the address and store in the local storage
   */
  const handleAutocompleteLoad = (autocomplete) => {
    // addressFromRef.current = autocomplete;
  };
  const handleOnPlaceChanged = (state) => {
    // console.log(addressFromRef.current?.getPlace());
    // const address = state.getPlace();
    // populateAddressObject(address.address_components, storageOption);
  };
  const [searchResult, setSearchResult] = useState(null);
  const [addressFrom, setAddressFrom] = useState(null);
  const [addressTo, setAddressTo] = useState(null);
  function onLoad(autocomplete, state) {
    if (state === "addressFrom") {
      setAddressFrom(autocomplete);
    }
    if (state === "addressTo") {
      setAddressTo(autocomplete);
    }
  }
  function onPlaceChanged(state, storageOption) {
    if (state === "addressFrom") {
      const address = addressFrom.getPlace();
      populateAddressObject(address.address_components, storageOption);
    }
    if (state === "addressTo") {
      const address = addressTo.getPlace();
      populateAddressObject(address.address_components, storageOption);
    }
  }

  /**
   * Function to handle the address data from Google maps and save on local Storage.
   */
  async function populateAddressObject(addressComponents, storageOption) {
    //Call function to get the details array
    var detailsArray = await populateDetailArray();
    //Address Object
    var LocalAddressObject = {
      Local_Address_Building_Name: "",
      Local_Address_Unit_Number: "",
      Local_Address_Street_Number: "",
      Local_Address_Street_Name: "",
      Local_Address_Suburb: "",
      Local_Address_City: "",
      Local_Address_State_Region: "",
      Local_Address_Country: "",
      Local_Address_Post_Code: "",
    };
    //Populating address object for each item
    addressComponents.forEach((item) => {
      switch (item.types[0]) {
        case "subpremise":
          LocalAddressObject.Local_Address_Unit_Number = item.long_name;
          break;
        case "street_number":
          LocalAddressObject.Local_Address_Street_Number = item.long_name;
          break;
        case "route":
          LocalAddressObject.Local_Address_Street_Name = item.long_name;
          break;
        case "sublocality_level_1":
          LocalAddressObject.Local_Address_Suburb = item.long_name;
        case "locality":
          LocalAddressObject.Local_Address_City = item.long_name;
          break;
        // case "administrative_area_level_2":
        //   LocalAddressObject.Local_From_Address_City = item.long_name;
        //   break;
        case "administrative_area_level_1":
          LocalAddressObject.Local_Address_State_Region = item.long_name;
          break;
        case "country":
          LocalAddressObject.Local_Address_Country = item.long_name;
          break;
        case "postal_code":
          LocalAddressObject.Local_Address_Post_Code = item.long_name;
          break;
        default:
          break;
      }
    });
    //Checking in which position of the array will update the addess
    //1 === ADDRESS FROM Array & 2 ==== ADDRESS TO ARRAY
    if (storageOption === 1) {
      detailsArray.addressFromArray = LocalAddressObject;
    } else {
      detailsArray.addressToArray = LocalAddressObject;
    }
    //Call function to update the local storage
    await updateLocalStorage(detailsArray);
    return LocalAddressObject;
  }

  const clearInputError = (name, value) => {
    const customErrorKey = {
      addressFromStr: "addressFrom",
      addressToStr: "addressTo",
      genderFromDesc: "genderFrom",
      genderToDesc: "genderTo",
    };

    const errorKey = customErrorKey[name] || name;

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[errorKey];
      }
      return newErrors;
    });
  };

  /**
   * Function to handle multiple inputs, including addresses.
   * Identifies the input by name, updates the relevant state, details array, and local storage.
   * @param {Object} e - Event object from the input change
   */
  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    const detailsArray = await populateDetailArray();

    // Update state and detailsArray based on the input name
    switch (name) {
      case "genderFromDesc":
        const intValue = parseInt(value);
        detailsArray.genderFromId = intValue;
        const genderOptionDesc =
          gender.find((item) => item.Gender_ID === intValue)
            ?.Gender_Description || "";
        detailsArray.genderFromDesc = genderOptionDesc;
        break;
      case "genderToDesc":
        const intValue2 = parseInt(value);
        detailsArray.genderToId = intValue2;
        const genderOptionToDesc =
          gender.find((item) => item.Gender_ID === intValue2)
            ?.Gender_Description || "";
        detailsArray.genderToDesc = genderOptionToDesc;
        break;
      default:
        detailsArray[name] = value;
        break;
    }

    // Update list state and local storage
    setListDetails(detailsArray);
    await updateLocalStorage(detailsArray);
    clearInputError(name, value);
  };

  /**
   * Function to update the DATES in the local storage.
   */
  async function updateDatesLS(dateName, dateDisplay, dateFormat) {
    const detailsArray = await populateDetailArray();

    const dateMap = {
      moveOutDate: { setDate: "moveOutDate", display: "moveOutDate" },
      moveInDate: { setDate: "moveInDate", display: "moveInDate" },
    };

    if (dateMap[dateName]) {
      detailsArray[dateMap[dateName].setDate] = dateFormat;
      detailsArray.datesToString[dateMap[dateName].display] = dateDisplay;
    }
    // Update local storage
    await updateLocalStorage(detailsArray);
  }

  /**
   * Function to handle all Input Dates and store into Local Storage
   *Also, logic to convert the date format from dd/mm/yyyy to yyyy-mm-dd.
   */
  const handleInputDates = async (e) => {
    //Format date and call function to update the local storage when the dateValue has full value dd/mm/yyyy
    const dateValue = e.target.value;
    const dateName = e.target.name;
    if (dateValue.length === 10) {
      // Split the input date string into day, month, and year parts
      const [year, month, day] = dateValue.split("-");
      // Format the date as dd/mm/yyyy
      const newDateFormat = `${day.padStart(2, "0")}/${month.padStart(
        2,
        "0"
      )}/${year}`;

      updateDatesLS(dateName, newDateFormat, dateValue);

      clearInputError(dateName, dateValue);
    } else {
      updateDatesLS(dateName, dateValue, "INVALID-DATE");
    }
  };

  const validatePath = async () => {
    const isValid = await handleEmptyAndEqualsField();

    if (isValid) {
      navigate("/dashboard-organisations");
    } else {
      return null;
    }
  };

  const handleFileUpload = () => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      documents: "",
    }));
  };

  //Function to validate the inputs
  const handleEmptyAndEqualsField = async () => {
    // Populate the details array
    const detailsArray = await populateDetailArray();
    // Destructure the options selected from displayDetails
    const { address, name, gender, emailAddress, mobileNumber } =
      displayDetails;

    // Helper function to check if either value is empty or equal
    const isEqual = (from, to) => from === to;
    const isEmpty = (value) =>
      value === "" || value === null || value === undefined;
    const isInvalid = (value) => isEmpty(value) || value === "INVALID-DATE";

    // Initialize an errors object
    let newErrors = {};
    let isValid = true;
    let openState = { from: false, to: false };

    // Function to validate name fields
    const validateField = (
      msgFieldName,
      keyName,
      fromValue,
      toValue,
      optional = false
    ) => {
      if (isEmpty(fromValue) && !optional) {
        newErrors[`${keyName}From`] = `${msgFieldName} FROM can't be blank.`;
        isValid = false;
        openState.from = true;
      }
      if (isEmpty(toValue) && !optional) {
        newErrors[`${keyName}To`] = `${msgFieldName} TO can't be blank.`;
        isValid = false;
        openState.to = true;
      } else if (isEqual(fromValue, toValue) && !optional) {
        if (
          keyName !== "givenName" &&
          keyName !== "familyName" &&
          keyName !== "middleName"
        ) {
          newErrors[`${keyName}From`] = `${msgFieldName} can't be the same.`;
          newErrors[`${keyName}To`] = `${msgFieldName} can't be the same.`;
          isValid = false;
          openState.from = true;
          openState.to = true;
        }
      }
    };

    // Validation checks
    if (address) {
      const { addressFromStr, addressToStr, moveInDate, moveOutDate } =
        detailsArray;
      validateField("Address", "address", addressFromStr, addressToStr);
      if (isEmpty(moveInDate)) {
        newErrors.moveInDate = `Move in date can't be blank.`;
        isValid = false;
      }
      if (isEmpty(moveOutDate)) {
        newErrors.moveOutDate = `Move out date can't be blank.`;
        isValid = false;
      }
    }
    if (name) {
      const {
        givenNameFrom,
        givenNameTo,
        middleNameFrom,
        middleNameTo,
        familyNameFrom,
        familyNameTo,
      } = detailsArray;
      validateField("Given name", "givenName", givenNameFrom, givenNameTo);
      validateField(
        "Middle name",
        "middleName",
        middleNameFrom,
        middleNameTo,
        true
      );
      validateField("Family name", "familyName", familyNameFrom, familyNameTo);
    }

    if (gender) {
      const { genderFromDesc, genderToDesc } = detailsArray;
      validateField("Gender", "gender", genderFromDesc, genderToDesc);
    }
    if (emailAddress) {
      const { emailFrom, emailTo } = detailsArray;
      validateField("Email address", "email", emailFrom, emailTo);
    }
    if (mobileNumber) {
      const { mobileNumberFrom, mobileNumberTo } = detailsArray;
      validateField(
        "Mobile Number",
        "mobileNumber",
        mobileNumberFrom,
        mobileNumberTo
      );
    }
    const { documents } = detailsArray;
    if ((gender || name) && (!documents || !documents.length)) {
      newErrors["documents"] = `Document can't be blank.`;
      isValid = false;
    }

    // Update errors state
    setErrors(newErrors);
    setOpen(openState);

    return isValid;
  };

  const toggleExpandable = (type) => {
    setOpen((prevState) => ({
      ...prevState,
      [type]: !prevState[type],
    }));
  };

  return (
    <>
      <AuthenticatedTemplate>
        <section className="step__container">
          <div className="step__content">
            <div className="update-details">
              <div className="step__header">
                <img
                  className="logo"
                  src={LOGOS.QUICKMOVE_FLOW}
                  alt="Quickmove logo"
                />
                <h1 className="text-md text-md--variant">
                  Let's update your details
                </h1>
              </div>

              <ProgressBar percentage="14" />

              <div className="group-options group-options--desktop">
                <div className="group-options__header">
                  <div className="group-options__item">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Change From
                    </h2>
                  </div>
                  <div className="group-options__item">
                    <img src={ICONS.SETA_ICON} alt="Caret" />
                  </div>
                  <div className="group-options__item">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Change To
                    </h2>
                  </div>
                </div>

                {displayDetails?.address ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Address
                    </h3>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="addressFrom">Address</label>
                        {isLoaded && (
                          <Autocomplete
                            onLoad={(e) => onLoad(e, "addressFrom")}
                            onPlaceChanged={() =>
                              onPlaceChanged("addressFrom", 1)
                            }
                          >
                            <input
                              id="addressFrom"
                              type="text"
                              placeholder={
                                listDetails?.addressFromStr
                                  ? listDetails.addressFromStr
                                  : "Enter your old address"
                              }
                              name="addressFromStr"
                              onChange={handleInputChange}
                              onBlur={handleInputChange}
                            ></input>
                          </Autocomplete>
                        )}
                        {errors.addressFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.addressFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img src={ICONS.SETA_ICON} alt="Caret icon" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="addressTo">Address</label>
                        {isLoaded && (
                          <Autocomplete
                            onLoad={(e) => onLoad(e, "addressTo")}
                            onPlaceChanged={() =>
                              onPlaceChanged("addressTo", 2)
                            }
                          >
                            <input
                              id="addressTo"
                              type="text"
                              placeholder={
                                listDetails?.addressToStr
                                  ? listDetails.addressToStr
                                  : "Enter your address"
                              }
                              name="addressToStr"
                              onChange={handleInputChange}
                              onBlur={handleInputChange}
                            ></input>
                          </Autocomplete>
                        )}
                        {errors.addressTo && (
                          <p className="paragraph-md text-danger">
                            {errors.addressTo}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="moveOutDate">Move out Date</label>
                        <input
                          type="date"
                          name="moveOutDate"
                          id="moveOutDate"
                          onChange={handleInputDates}
                          style={{ width: "100%" }}
                        ></input>
                        {errors.moveOutDate && (
                          <p className="paragraph-md text-danger">
                            {errors.moveOutDate}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img className="" src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="moveInDate">Move in Date</label>
                        <input
                          type="date"
                          placeholder="Ex: dd/mm/yyyy"
                          name="moveInDate"
                          id="moveInDate"
                          onChange={handleInputDates}
                          style={{ width: "100%" }}
                        ></input>
                        {errors.moveInDate && (
                          <p className="paragraph-md text-danger">
                            {errors.moveInDate}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {displayDetails?.emailAddress ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Email Address
                    </h3>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="emailFrom">Email Address</label>
                        <input
                          type="email"
                          id="emailFrom"
                          name="emailFrom"
                          maxLength="50"
                          placeholder={
                            listDetails?.emailFrom
                              ? listDetails.emailFrom
                              : "Enter your email address"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.emailFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.emailFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img className="" src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="emailTo">Email Address</label>
                        <input
                          type="email"
                          id="emailTo"
                          name="emailTo"
                          maxLength="50"
                          placeholder={
                            listDetails?.emailTo
                              ? listDetails.emailTo
                              : "Enter your new email address"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.emailTo && (
                          <p className="paragraph-md text-danger">
                            {errors.emailTo}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {displayDetails?.name ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Name
                    </h3>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="givenNameFrom">Given Name</label>
                        <input
                          name="givenNameFrom"
                          id="givenNameFrom"
                          maxLength="100"
                          placeholder={
                            listDetails?.givenNameFrom
                              ? listDetails.givenNameFrom
                              : "Enter your old given name"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.givenNameFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.givenNameFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img className="" src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="givenNameTo">Given Name</label>
                        <input
                          name="givenNameTo"
                          id="givenNameTo"
                          type="text"
                          maxLength="100"
                          placeholder={
                            listDetails?.givenNameTo
                              ? listDetails.givenNameTo
                              : "Enter your new given name"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.givenNameTo && (
                          <p className="paragraph-md text-danger">
                            {errors.givenNameTo}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="middleNameFrom">Middle Name</label>
                        <input
                          name="middleNameFrom"
                          id="middleNameFrom"
                          type="text"
                          maxLength="100"
                          placeholder={
                            listDetails?.middleNameFrom
                              ? listDetails.middleNameFrom
                              : "Enter your old middle name"
                          }
                          onChange={handleInputChange}
                        ></input>
                        {errors.middleNameFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.middleNameFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img className="" src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="middleNameTo">Middle Name</label>
                        <input
                          name="middleNameTo"
                          id="middleNameTo"
                          type="text"
                          maxLength="100"
                          placeholder={
                            listDetails?.middleNameTo
                              ? listDetails.middleNameTo
                              : "Enter your new middle name"
                          }
                          onChange={handleInputChange}
                        ></input>
                        {errors.middleNameTo && (
                          <p className="paragraph-md text-danger">
                            {errors.middleNameTo}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="familyNameFrom">Family Name</label>
                        <input
                          name="familyNameFrom"
                          id="familyNameFrom"
                          maxLength="100"
                          type="text"
                          placeholder={
                            listDetails?.familyNameFrom
                              ? listDetails.familyNameFrom
                              : "Enter your old family name"
                          }
                          onChange={handleInputChange}
                        ></input>
                        {errors.familyNameFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.familyNameFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img className="" src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="familyNameTo">Family Name</label>
                        <input
                          name="familyNameTo"
                          id="familyNameTo"
                          type="text"
                          maxLength="100"
                          placeholder={
                            listDetails?.familyNameTo
                              ? listDetails.familyNameTo
                              : "Enter your new family name"
                          }
                          onChange={handleInputChange}
                        ></input>
                        {errors.familyNameTo && (
                          <p className="paragraph-md text-danger">
                            {errors.familyNameTo}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {displayDetails?.mobileNumber ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Phone Number
                    </h3>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="mobileNumberFrom">Mobile Phone</label>
                        <input
                          type="number"
                          maxLength="20"
                          name="mobileNumberFrom"
                          id="mobileNumberFrom"
                          placeholder={
                            listDetails?.mobileNumberFrom
                              ? listDetails.mobileNumberFrom
                              : "Enter your old mobile phone number"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.mobileNumberFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.mobileNumberFrom}
                          </p>
                        )}
                      </div>
                      <div className="group-options__chevron">
                        <img src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="mobileNumberTo">Mobile Phone</label>
                        <input
                          type="number"
                          maxLength="20"
                          name="mobileNumberTo"
                          id="mobileNumberTo"
                          placeholder={
                            listDetails?.mobileNumberTo
                              ? listDetails.mobileNumberTo
                              : "Enter your new mobile phone number"
                          }
                          onChange={handleInputChange}
                        />
                        {errors.mobileNumberTo && (
                          <p className="paragraph-md text-danger">
                            {errors.mobileNumberTo}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {displayDetails?.gender ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Gender
                    </h3>
                    <div className="group-options__row">
                      <div className="group-options__from">
                        <label htmlFor="genderFrom">Gender</label>
                        <select
                          name="genderFromDesc"
                          id="genderFrom"
                          defaultValue={listDetails?.genderFromDesc}
                          onChange={handleInputChange}
                          onBlur={handleInputChange}
                        >
                          <option value="">{"Select"}</option>
                          {gender
                            ? gender.map((item) => (
                                <option
                                  value={item.Gender_ID}
                                  key={item.Gender_ID}
                                >
                                  {item.Gender_Description}
                                </option>
                              ))
                            : null}
                        </select>
                        {errors.genderFrom && (
                          <p className="paragraph-md text-danger">
                            {errors.genderFrom}
                          </p>
                        )}
                      </div>

                      <div className="group-options__chevron">
                        <img src={ICONS.SETA_ICON} alt="Caret" />
                      </div>
                      <div className="group-options__to">
                        <label htmlFor="genderTo">Gender</label>
                        <select
                          name="genderToDesc"
                          id="genderTo"
                          defaultValue={listDetails.genderToDesc}
                          onChange={handleInputChange}
                          onBlur={handleInputChange}
                        >
                          <option value="">{"Select"}</option>
                          {gender
                            ? gender.map((item) => (
                                <option
                                  value={item.Gender_ID}
                                  key={item.Gender_ID}
                                >
                                  {item.Gender_Description}
                                </option>
                              ))
                            : null}
                        </select>
                        {errors.genderTo && (
                          <p className="paragraph-md text-danger">
                            {errors.genderTo}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {displayUploadDoc ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Upload Document
                    </h3>
                    <div className="upload-document">
                      <label>Upload Document</label>
                      <UploadFile onFileUpload={handleFileUpload} />
                      {errors.documents && (
                        <p className="paragraph-md text-danger">
                          {errors.documents}
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="group-options group-options--mobile">
                {/* Toggle "from" */}
                <div className="expandable-details">
                  <div
                    className="expandable-details__header"
                    onClick={() => toggleExpandable("from")}
                  >
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      From
                    </h3>
                    <i
                      className={
                        "chevron-icon fas fa-chevron-" +
                        (isOpen["from"] ? "up" : "down")
                      }
                    ></i>
                  </div>

                  {isOpen["from"] && (
                    <div
                      className={`expandable-details__content ${
                        isOpen["from"]
                          ? "expandable-details__content--active"
                          : ""
                      }`}
                    >
                      {displayDetails?.address ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Address
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="addressFromStr">Address</label>
                              {isLoaded && window.innerWidth < 768 && (
                                <Autocomplete>
                                  <input
                                    id="addressFromStr"
                                    type="text"
                                    placeholder={
                                      listDetails?.addressFromStr
                                        ? listDetails.addressFromStr
                                        : "Enter your old address"
                                    }
                                    name="addressFromStr"
                                    onChange={handleInputChange}
                                    onBlur={handleInputChange}
                                  ></input>
                                </Autocomplete>
                              )}
                              {errors.addressFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.addressFrom}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="moveOutDate">Move out Date</label>
                              <input
                                id="moveOutDate"
                                type="date"
                                name="moveOutDate"
                                onChange={handleInputDates}
                                style={{ width: "100%" }}
                              ></input>
                              {errors.moveOutDate && (
                                <p className="paragraph-md text-danger">
                                  {errors.moveOutDate}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.emailAddress ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Email Address
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label>Email Address</label>
                              <input
                                type="email"
                                name="emailFrom"
                                maxLength="50"
                                placeholder={
                                  listDetails?.emailFrom
                                    ? listDetails.emailFrom
                                    : "Enter your email address"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.emailFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.emailFrom}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.name ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Name
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="givenNameFrom">Given Name</label>
                              <input
                                name="givenNameFrom"
                                id="givenNameFrom"
                                maxLength="100"
                                placeholder={
                                  listDetails?.givenNameFrom
                                    ? listDetails.givenNameFrom
                                    : "Enter your old given name"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.givenNameFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.givenNameFrom}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="middleNameFrom">
                                Middle Name
                              </label>
                              <input
                                name="middleNameFrom"
                                id="middleNameFrom"
                                type="text"
                                maxLength="100"
                                placeholder={
                                  listDetails?.middleNameFrom
                                    ? listDetails.middleNameFrom
                                    : "Enter your old middle name"
                                }
                                onChange={handleInputChange}
                              ></input>
                              {errors.middleNameFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.middleNameFrom}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="familyNameFrom">
                                Family Name
                              </label>
                              <input
                                name="familyNameFrom"
                                id="familyNameFrom"
                                maxLength="100"
                                type="text"
                                placeholder={
                                  listDetails?.familyNameFrom
                                    ? listDetails.familyNameFrom
                                    : "Enter your old family name"
                                }
                                onChange={handleInputChange}
                              ></input>
                              {errors.familyNameFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.familyNameFrom}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.mobileNumber ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Phone Number
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="mobileNumberFrom">
                                Mobile Phone
                              </label>
                              <input
                                type="number"
                                maxLength="20"
                                name="mobileNumberFrom"
                                id="mobileNumberFrom"
                                placeholder={
                                  listDetails?.mobileNumberFrom
                                    ? listDetails.mobileNumberFrom
                                    : "Enter your old mobile phone number"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.mobileNumberFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.mobileNumberFrom}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.gender ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Gender
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__from">
                              <label htmlFor="genderFromDesc">Gender</label>
                              <select
                                name="genderFromDesc"
                                id="genderFromDesc"
                                defaultValue={listDetails?.genderFromDesc}
                                onChange={handleInputChange}
                                onBlur={handleInputChange}
                              >
                                <option value="">{"Select"}</option>
                                {gender
                                  ? gender.map((item) => (
                                      <option
                                        value={item.Gender_ID}
                                        key={item.Gender_ID}
                                      >
                                        {item.Gender_Description}
                                      </option>
                                    ))
                                  : null}
                              </select>
                              {errors.genderFrom && (
                                <p className="paragraph-md text-danger">
                                  {errors.genderFrom}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                {/* Toggle "to" */}
                <div className="expandable-details">
                  <div
                    className="expandable-details__header"
                    onClick={() => toggleExpandable("to")}
                  >
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      To
                    </h3>
                    <i
                      className={
                        "chevron-icon fas fa-chevron-" +
                        (isOpen["to"] ? "up" : "down")
                      }
                    ></i>
                  </div>

                  {isOpen["to"] && (
                    <div className="expandable-details__content">
                      {displayDetails?.address ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Address
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="addressTo">Address</label>
                              {isLoaded && window.innerWidth < 768 && (
                                <Autocomplete
                                  onLoad={(e) => onLoad(e, "addressTo")}
                                  onPlaceChanged={() =>
                                    onPlaceChanged("addressTo", 1)
                                  }
                                >
                                  <input
                                    id="addressTo"
                                    type="text"
                                    placeholder={
                                      listDetails?.addressToStr
                                        ? listDetails.addressToStr
                                        : "Enter your address"
                                    }
                                    name="addressToStr"
                                    onChange={handleInputChange}
                                    onBlur={handleInputChange}
                                  ></input>
                                </Autocomplete>
                              )}
                              {errors.addressTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.addressTo}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="moveInDate">Move in Date</label>
                              <input
                                id="moveInDate"
                                type="date"
                                placeholder="Ex: dd/mm/yyyy"
                                name="moveInDate"
                                onChange={handleInputDates}
                                style={{ width: "100%" }}
                              ></input>
                              {errors.moveInDate && (
                                <p className="paragraph-md text-danger">
                                  {errors.moveInDate}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.emailAddress ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Email Address
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="emailTo">Email Address</label>
                              <input
                                type="email"
                                name="emailTo"
                                maxLength="50"
                                placeholder={
                                  listDetails?.emailTo
                                    ? listDetails.emailTo
                                    : "Enter your new email address"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.emailTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.emailTo}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.name ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Name
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="givenNameTo">Given Name</label>
                              <input
                                name="givenNameTo"
                                id="givenNameTo"
                                type="text"
                                maxLength="100"
                                placeholder={
                                  listDetails?.givenNameTo
                                    ? listDetails.givenNameTo
                                    : "Enter your new given name"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.givenNameTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.givenNameTo}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="middleNameTo">Middle Name</label>
                              <input
                                name="middleNameTo"
                                id="middleNameTo"
                                type="text"
                                maxLength="100"
                                placeholder={
                                  listDetails?.middleNameTo
                                    ? listDetails.middleNameTo
                                    : "Enter your new middle name"
                                }
                                onChange={handleInputChange}
                              ></input>
                              {errors.middleNameTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.middleNameTo}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="familyNameTo">Family Name</label>
                              <input
                                name="familyNameTo"
                                id="familyNameTo"
                                type="text"
                                maxLength="100"
                                placeholder={
                                  listDetails?.familyNameTo
                                    ? listDetails.familyNameTo
                                    : "Enter your new family name"
                                }
                                onChange={handleInputChange}
                              ></input>
                              {errors.familyNameTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.familyNameTo}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.mobileNumber ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Phone Number
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="mobileNumberTo">
                                Mobile Phone
                              </label>
                              <input
                                type="number"
                                maxLength="20"
                                name="mobileNumberTo"
                                id="mobileNumberTo"
                                placeholder={
                                  listDetails?.mobileNumberTo
                                    ? listDetails.mobileNumberTo
                                    : "Enter your new mobile phone number"
                                }
                                onChange={handleInputChange}
                              />
                              {errors.mobileNumberTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.mobileNumberTo}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {displayDetails?.gender ? (
                        <div className="group-options__card">
                          <h3 className="paragraph-md semibold paragraph-md--dark">
                            Gender
                          </h3>
                          <div className="group-options__row">
                            <div className="group-options__to">
                              <label htmlFor="genderTo">Gender</label>
                              <select
                                name="genderToDesc"
                                id="genderTo"
                                defaultValue={listDetails.genderToDesc}
                                onChange={handleInputChange}
                                onBlur={handleInputChange}
                              >
                                <option value="">{"Select"}</option>
                                {gender
                                  ? gender.map((item) => (
                                      <option
                                        value={item.Gender_ID}
                                        key={item.Gender_ID}
                                      >
                                        {item.Gender_Description}
                                      </option>
                                    ))
                                  : null}
                              </select>
                              {errors.genderTo && (
                                <p className="paragraph-md text-danger">
                                  {errors.genderTo}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                {displayUploadDoc ? (
                  <div className="group-options__card">
                    <h3 className="paragraph-md semibold paragraph-md--dark">
                      Upload Document
                    </h3>
                    <div className="upload-document">
                      <label>Upload Document</label>
                      <UploadFile onFileUpload={handleFileUpload} />
                      {errors.documents && (
                        <p className="paragraph-md text-danger">
                          {errors.documents}
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="action-buttons">
                <Link to="/dashboard-welcome">
                  <Button variant="outlined">Back</Button>
                </Link>
                <Button
                  variant="primary"
                  icon={ICONS.CARET_ICON}
                  iconAlt={"Caret icon"}
                  onClick={() => validatePath()}
                >
                  Continue
                </Button>
              </div>
              <Footer />
            </div>
          </div>
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
